<template>
    <div class="pb-4 mb-4 border-b">
        <div class="flex items-center">
            <h2 class="text-lg font-medium">{{ title }}</h2>
            <button
                type="button"
                @click="$emit('removed')"
                class="ml-4 bg-red-500 text-white hover:bg-red-600 transition duration-300 px-4 py-2 text-sm"
            >
                Remove
            </button>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-4">
            <ValidationProvider tag="div" :name="`First Name ${index}`" rules="required|max:100" class="flex flex-col" v-slot="{ errors }">
                <label for="" class="text-gray-600 block text-xs mb-1">First Name</label>
                <input
                    class="text-sm"
                    :class="{ 'border-red-500': errors[0] }"
                    type="text"
                    v-model="model.first_name"
                />
                <span class="text-xs text-red-500 mt-1">{{ errors[0] }}</span>
            </ValidationProvider>
            <ValidationProvider tag="div" :name="`Last Name ${index}`" rules="required|max:100" class="flex flex-col" v-slot="{ errors }">
                <label for="" class="text-gray-600 block text-xs mb-1">Last Name</label>
                <input class="text-sm" :class="{ 'border-red-500': errors[0] }" type="text" v-model="model.last_name" />
                <span class="text-xs text-red-500 mt-1">{{ errors[0] }}</span>
            </ValidationProvider>
            <ValidationProvider tag="div" :name="`Email ${index}`" rules="required|email" class="flex flex-col" v-slot="{ errors }">
                <label for="" class="text-gray-600 block text-xs mb-1">Email</label>
                <input class="text-sm" :class="{ 'border-red-500': errors[0] }" type="text" v-model="model.email" />
                <span class="text-xs text-red-500 mt-1">{{ errors[0] }}</span>
            </ValidationProvider>
            <ValidationProvider tag="div" :name="`Cell Phone ${index}`" rules="required|digits:10" class="flex flex-col" v-slot="{ errors }">
                <label for="" class="text-gray-600 block text-xs mb-1">Cell Phone</label>
                <input
                    class="text-sm"
                    :class="{ 'border-red-500': errors[0] }"
                    type="text"
                    v-model="model.cell_phone"
                />
                <span class="text-xs text-red-500 mt-1">{{ errors[0] }}</span>
            </ValidationProvider>
            <ValidationProvider tag="div" :name="`SIN ${index}`" rules="" class="flex flex-col" v-slot="{ errors }">
                <label for="" class="text-gray-600 block text-xs mb-1">Social Insurance Number</label>
                <input class="text-sm" type="text" v-model="model.ssn" />                   
                <span class="text-xs text-red-500 mt-1">{{ errors[0] }}</span>
            </ValidationProvider>
            <ValidationProvider
                tag="div"
                :name="`Date of Birth ${index}`"
                rules="required"
                class="flex flex-col"
                v-slot="{ errors }"
            >
                <label for="" class="text-gray-600 block text-xs mb-1">Date of Birth</label>
                <input class="text-sm" :class="{ 'border-red-500': errors[0] }" type="date" v-model="model.dob" />
                <span class="text-xs text-red-500 mt-1">{{ errors[0] }}</span>
            </ValidationProvider>
            <ValidationProvider
                tag="div"
                :name="`Your Address ${index}`"
                rules="required|max:200"
                class="flex flex-col"
                v-slot="{ errors }"
            >
                <label for="" class="text-gray-600 block text-xs mb-1">Your Address</label>
                <input class="text-sm" :class="{ 'border-red-500': errors[0] }" type="text" v-model="model.address" />
                <span class="text-xs text-red-500 mt-1">{{ errors[0] }}</span>
            </ValidationProvider>
            <ValidationProvider tag="div" :name="`City ${index}`" rules="required|max:100" class="flex flex-col" v-slot="{ errors }">
                <label for="" class="text-gray-600 block text-xs mb-1">City</label>
                <input class="text-sm" :class="{ 'border-red-500': errors[0] }" type="text" v-model="model.city" />
                <span class="text-xs text-red-500 mt-1">{{ errors[0] }}</span>
            </ValidationProvider>
            <ValidationProvider tag="div" :name="`Postal Code ${index}`" rules="required|max:7" class="flex flex-col" v-slot="{ errors }">
                <label for="" class="text-gray-600 block text-xs mb-1">Postal Code</label>
                <input
                    class="text-sm"
                    :class="{ 'border-red-500': errors[0] }"
                    type="text"
                    v-model="model.postal_code"
                />
                <span class="text-xs text-red-500 mt-1">{{ errors[0] }}</span>
            </ValidationProvider>
            <ValidationProvider tag="div" :name="`Province ${index}`" rules="required" class="flex flex-col" v-slot="{ errors }">
                <label for="" class="text-gray-600 block text-xs mb-1">Province</label>
                <select :class="{ 'border-red-500': errors[0] }" class="text-sm" v-model="model.state">

                            <option value="">Select Province</option>
                            <option value="AB">Alberta</option>
                            <option value="BC">British Columbia</option>
                            <option value="MB">Manitoba</option>
                            <option value="NB">New Brunswick</option>
                            <option value="NL">Newfoundland and Labrador</option>
                            <option value="NS">Nova Scotia</option>
                            <option value="ON">Ontario</option>
                            <option value="PE">Prince Edward Island</option>
                            <option value="QC">Quebec</option>
                            <option value="SK">Saskatchewan</option>
                            <option value="NT">Northwest Territories</option>
                            <option value="NU">Nunavut</option>
                            <option value="YT">Yukon Territory</option>
                        </select>
                <span class="text-xs text-red-500 mt-1">{{ errors[0] }}</span>
            </ValidationProvider>
            <ValidationProvider
                tag="div"
                :name="`Job Title/Position ${index}`"
                rules="required|max:100"
                class="flex flex-col"
                v-slot="{ errors }"
            >
                <label for="" class="text-gray-600 block text-xs mb-1">Job Title/Position</label>
                <input class="text-sm" :class="{ 'border-red-500': errors[0] }" type="text" v-model="model.position" />
                <span class="text-xs text-red-500 mt-1">{{ errors[0] }}</span>
            </ValidationProvider>
            <ValidationProvider
                tag="div"
                :name="`Ownership Percentage (1-100%) ${index}`"
                rules="required|min_value:1|max_value:100"
                class="flex flex-col"
                v-slot="{ errors }"
            >
                <label for="" class="text-gray-600 block text-xs mb-1">Ownership Percentage (1-100%)</label>
                <input
                    class="text-sm"
                    :class="{ 'border-red-500': errors[0] }"
                    type="text"
                    v-model="model.ownership_percentage"
                />
                <span class="text-xs text-red-500 mt-1">{{ errors[0] }}</span>
            </ValidationProvider>
            <ValidationProvider
                tag="div"
                :name="`Annual Income ${index}`"
                rules="required|min_value:1|max_value:999999"
                class="flex flex-col"
                v-slot="{ errors }"
            >
                <label for="" class="text-gray-600 block text-xs mb-1">Annual Income</label>
                <input
                    class="text-sm"
                    :class="{ 'border-red-500': errors[0] }"
                    type="text"
                    v-model="model.annual_income"
                />
                <span class="text-xs text-red-500 mt-1">{{ errors[0] }}</span>
            </ValidationProvider>
        </div>

        <Signature @signatureUpdated="onSignatureUpdate" :model="model" :title="title" />
    </div>
</template>

<script>
import Signature from './Signature'
export default {
    props: ['title', 'model', 'index'],
    components: {Signature},
    methods: {
        onSignatureUpdate(event) {
            this.$emit('signatureUpdated', event);
        }
    }
};
</script>